/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 09:58 2022/05/26
 * 趋势管理
 */

 import * as Vue from 'vue-tsx-support';
 import { Component } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import { createBEM } from 'src/util/bem';
 import '../stationDetail.less';
 import StationSider from 'src/pages/stationDetail/component/stationSider';
 import { MenuI } from 'src/pages/store/modules/layout';
 import MenuBtn from 'src/pages/layout/components/menuBtn';
 import TendencyManage from '../component/tendencyManage';
 import Bus, { Events } from 'src/util/bus';
 import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
 let bem = createBEM('station-detail');
 @Component({name: 'station-detail'})
 export default class StationDetail extends Vue.Component<any> {
    mn = ''
    mounter() {
        this.mn = this.$route.query.mn
    }

     stationChange(data: StationListDOI.RowDataI) {
         this.$router.replace({
             query: { mn: data.mn + '',productId: data.product_id+'', id: data.id+"",factorset: data.factorset+'' }
         })
     }
     created() {
        Bus.$on(Events.StationChange, this.stationChange); 
         
     }
 
     beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
     }
 
     render(h) {
         return (
             <div class={bem()}>
                 <div class={bem('side')}>
                     <StationSider mn={this.$route.query.mn}  id={+this.$route.query.id }/>
                 </div>
                 <div class={bem('content')}>
                     <div class={bem('menu')}>
                         <MenuBtn value={this.currentMenu} onInput={this.menuChange} showBack={true} />
                     </div>
                     <TendencyManage></TendencyManage>
                 </div>
             </div>
         );
     }
 }
 